import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { StyleViewerPage } from './pages/StyleViewerPage';
import { AppStoreProvider } from './store/appStore';
import { useAppLifecycle } from './App.hooks';
const ROUTER_FUTURE = { v7_relativeSplatPath: true, v7_startTransition: true };
const AppInner = () => {
    useAppLifecycle();
    return (_jsx(BrowserRouter, { future: ROUTER_FUTURE, children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(StyleViewerPage, {}) }), _jsx(Route, { path: "*", element: _jsx(StyleViewerPage, {}) })] }) }));
};
export const App = () => {
    return (_jsxs(AppStoreProvider, { children: [_jsx(AppInner, {}), _jsx("div", { id: "dialog-root" })] }));
};
